export default "__VITE_ASSET__CZpRrPXl__"